import React, { useMemo } from "react";
import {
	FormControl,
	Grid,
	MenuItem,
	Select,
	SelectChangeEvent,
	Typography
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store";
import { setUserSelected } from "../../store/auth/auth.action";

export function ChoixDelegant() {
	const { delegants, user } = useAppSelector((s) => s.auth);
	const isAdminMode = useAppSelector((s) => s.auth.isAdminMode);
	const userInAdminMode = useAppSelector((s) => s.auth.user);
	const dispatch = useAppDispatch();

	const onChange = React.useCallback(
		(e: SelectChangeEvent) => {
			dispatch(setUserSelected(e.target.value));
		},
		[dispatch]
	);

	// Calcul de la taille minimale de l'input afin d'éviter que le texte se déplace en fonction de la valeur choisie
	const minWidth = useMemo(() => {
		const size =
			delegants.reduce((acc, current) => {
				if (acc < current.libelle.length) return current.libelle.length;
				return acc;
			}, 0) + 9;
		return size + "ch";
	}, [delegants]);

	return (
		<Grid container className={"ChoixDelegant"} alignItems={"center"} spacing={2}>
			<Grid item>
				<Typography>Agir en tant que</Typography>
			</Grid>

			<Grid item minWidth={minWidth}>
				<FormControl fullWidth>
					<Select
						variant={"standard"}
						className={"input"}
						id="choix-delegant-select"
						value={user?.idTechPs ?? ""}
						onChange={onChange}
						disabled={!!isAdminMode}
					>
						{isAdminMode && userInAdminMode ? (
							<MenuItem value={userInAdminMode!.idTechPs} key={userInAdminMode!.idTechPs}>
								{userInAdminMode!.libelle}
							</MenuItem>
						) : (
							delegants.map((usr) => (
								<MenuItem value={usr.idTechPs} key={usr.idTechPs}>
									{usr.libelle}
								</MenuItem>
							))
						)}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	);
}